import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ThreeDService } from '../services/three-d.service';
import { ConfigurationService } from '../services/configuration.service';
import { ErrorService } from '../services/error.service';
import { ErrorTypes } from '../enums/errorTypes.enum';
import { StartupService } from '../services/startup.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-model-view',
  templateUrl: './model-view.component.html',
  styleUrls: ['./model-view.component.scss'],
})
export class ModelViewComponent implements OnInit, AfterViewInit {
  @ViewChild('iframe') iframeElement;
  init = false;
  configurationReady = false;
  timeOutCounter = 0;
  safeResourceUrl: SafeResourceUrl;

  get visibility() {
    return this.configurationReady ? 'visible' : 'hidden';
  }

  private get iframe() {
    return this.iframeElement.nativeElement as HTMLIFrameElement;
  }

  constructor(
    private threeDService: ThreeDService,
    private configurationService: ConfigurationService,
    private errorService: ErrorService,
    private startUpService: StartupService,
    private domSanitizer: DomSanitizer,
    public cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.startUpService.initialized$.subscribe((ready: boolean) => {
      this.configurationReady = ready;
      if (ready) {
        let url = 'assets/3d/index.html';
        if (!this.hasToken()) {
          url += '?nologo=true';
        }
        this.safeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
      }
    });

    this.setVisibilityEvents();
  }

  setVisibilityEvents() {
    document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), false);
  }

  handleVisibilityChange() {
    if (!document.hidden && !this.init) {
      this.timeOutCounter = 0;
      setTimeout(() => {
        this.runRecursiveLoader();
      });
    }
  }

  ngAfterViewInit() {
    if (!document.hidden) {
      this.runRecursiveLoader();
    }
  }

  runRecursiveLoader() {
    if (document.hidden) {
      return;
    }
    setTimeout(() => {
      if (this.iframe.contentWindow) {
        this.setIframeResetModel();
      }
      if (this.errorService.errorThrown) {
        return;
      }
      if (this.timeOutCounter > 500) {
        this.errorService.throwError(ErrorTypes.IframeNotConnected);
        return;
      }

      if (!this.init) {
        if (document.readyState === 'complete') {
          this.timeOutCounter++;
        }
        this.runRecursiveLoader();
      }
    }, 20);
  }

  setIframeResetModel() {
    if (this.init) {
      return;
    }
    this.init = this.threeDService.setIframe(this.iframe.contentWindow);
    setTimeout(() => {
      this.configurationService.updatePrice$.emit(this.configurationService.configuration);
    });
  }

  private hasToken(): boolean {
    const hasIt = !!this.startUpService.token;
    return hasIt;
  }
}
